<template>
  <svg width="51" height="72" viewBox="0 0 51 72" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M16.0913 37.1024C17.9304 33.9626 21.3027 31.9191 25.0856 31.9191C20.4738 31.9191 16.7236 28.1689 16.7236 23.5571C16.7236 18.9454 20.4738 15.1951 25.0856 15.1951C29.6974 15.1951 33.4476 18.9454 33.4476 23.5571C33.4476 28.1689 29.6974 31.9191 25.0856 31.9191C28.8686 31.9191 32.2408 33.9626 34.0799 37.1024C37.4867 34.4207 39.7191 30.3091 39.7191 25.6476C39.7191 17.5796 33.1537 11.0142 25.0856 11.0142C17.0176 11.0142 10.4521 17.5796 10.4521 25.6476C10.4521 30.3091 12.6845 34.4207 16.0913 37.1024V37.1024Z"
      fill="#7083BA"
    />
    <path
      d="M0 25.6477C0 42.8175 15.1398 48.2848 25.0859 59.0956C35.0247 48.2915 50.1719 42.8697 50.1719 25.6477C50.1719 11.8144 38.9192 0.422363 25.0859 0.422363C11.2527 0.422363 0 11.8144 0 25.6477ZM25.0859 6.83321C35.4608 6.83321 43.9004 15.2728 43.9004 25.6477C43.9004 36.0225 35.4608 44.4621 25.0859 44.4621C14.7111 44.4621 6.27148 36.0225 6.27148 25.6477C6.27148 15.2728 14.7111 6.83321 25.0859 6.83321Z"
      fill="#7083BA"
    />
    <path
      d="M38.5861 52.6318L25.0863 64.7058L11.5874 52.6313C5.58919 54.5069 2.09082 57.5528 2.09082 61.1862C2.09082 67.9763 13.9377 71.7781 25.0863 71.7781C36.2349 71.7781 48.0817 67.9763 48.0817 61.1862C48.0817 57.5531 44.5836 54.5076 38.5861 52.6318Z"
      fill="#7083BA"
    />
  </svg>
</template>
<script>
export default {
  name: 'ModalIcon',
};
</script>

<style scoped></style>
